class ProjectsAPI {

  static all(state) {
    let url = this.postsUrl(state)

    return fetch(url, {
      credentials: 'same-origin'
    })
    .then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }

  static postsUrl(params) {

    const {currentMarket, count, offset} = params

    let markets = currentMarket ? `&market=${currentMarket}` : ''

    const fields = 'id,title,excerpt,date,featured_media,link,market_names,feat_image,feat_image_srcset,has_detail_page,detail_url'
    return `/wp-json/wp/v2/projects?per_page=${count}&offset=${offset}&_fields=${fields}${markets}`
  }

}

export default ProjectsAPI



// WEBPACK FOOTER //
// ./src/js/projects/api/ProjectsAPI.js